import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import VideoCard from "@/components/feature/VideoCard";
import SectionHeading from "@/components/base/SectionHeading";
import { useFavorites } from "@/hooks/useFavorites";
import { usePageMeta } from "@/hooks/usePageMeta";
import { hotVideoIds } from "@/mocks/videos";
import { getHotVideos, getLatestVideos } from "@/utils/video";

export default function Home() {
  const { favorites } = useFavorites();
  usePageMeta(
    "91视频免费看-优质影视资源在线观看平台",
    "91视频免费看提供丰富多样的影视资源，包括电影和电视剧，方便用户在线观看各类热门影视作品，操作简单，内容更新及时。"
  );
  const hotVideos = getHotVideos(hotVideoIds);
  const latestVideos = getLatestVideos(8);
  const favoriteVideos = getHotVideos(favorites);

  return (
    <div>
      <HeroCarousel />

      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8 py-10 md:py-14 space-y-14">
        <section>
          <SectionHeading title="频道入口" subtitle="选择你想看的类型，快速直达" />
          <CategoryEntries />
        </section>

        {favoriteVideos.length > 0 && (
          <section>
            <div className="flex items-center gap-3 mb-5">
              <span className="w-1.5 h-7 rounded-full bg-accent-500"></span>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                我的收藏
                <span className="ml-2 text-sm font-normal text-foreground-500">{favoriteVideos.length} 部</span>
              </h2>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
              {favoriteVideos.map((item) => (
                <VideoCard key={item.id} item={item} showTypeBadge />
              ))}
            </div>
          </section>
        )}

        <section>
          <SectionHeading title="热门影视推荐" subtitle="当前最受欢迎的影视作品，大家都在看" moreTo="/movie" moreLabel="更多电影" />
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
            {hotVideos.map((item) => (
              <VideoCard key={item.id} item={item} showTypeBadge />
            ))}
          </div>
        </section>

        <section>
          <SectionHeading title="最新更新" subtitle="刚刚上线的热门影视，追剧不落伍" moreTo="/tv" moreLabel="更多剧集" />
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {latestVideos.map((item) => (
              <VideoCard key={item.id} item={item} showTypeBadge />
            ))}
          </div>
        </section>

        <section className="rounded-lg bg-primary-50 border border-primary-100 p-6 md:p-10">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-10 items-center">
            <div className="lg:col-span-2">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-primary-900">
                关于 91视频免费看
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
                91视频免费看致力于为影视爱好者提供丰富、及时、便捷的在线观看体验。
                平台汇聚电影与电视剧两大类内容，覆盖动作、爱情、科幻、悬疑、古装等热门题材，
                支持关键词搜索、分类筛选与分页浏览，让你以最简单的方式找到想看的作品。
              </p>
              <div className="mt-5 flex flex-wrap gap-3">
                <Link to="/about" className="inline-flex items-center gap-1 px-5 py-2.5 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap">
                  了解我们
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
                </Link>
                <Link to="/movie" className="inline-flex items-center gap-1 px-5 py-2.5 rounded-full bg-background-50 border border-primary-200 text-primary-700 text-sm font-medium hover:bg-primary-100 transition-colors whitespace-nowrap">
                  开始探索
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-3 lg:grid-cols-1 gap-4">
              <div className="text-center lg:text-left">
                <p className="font-heading text-2xl md:text-3xl font-bold text-accent-600">30+</p>
                <p className="mt-1 text-xs md:text-sm text-foreground-600">精选影视资源</p>
              </div>
              <div className="text-center lg:text-left">
                <p className="font-heading text-2xl md:text-3xl font-bold text-primary-600">10+</p>
                <p className="mt-1 text-xs md:text-sm text-foreground-600">热门影视类型</p>
              </div>
              <div className="text-center lg:text-left">
                <p className="font-heading text-2xl md:text-3xl font-bold text-accent-600">每日</p>
                <p className="mt-1 text-xs md:text-sm text-foreground-600">内容持续更新</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}